import {Component, Host, h, Prop, State, Listen, Event, EventEmitter} from '@stencil/core';
import {CLOSEBUTTON_COLORS_TYPES} from '../../utils'

@Component({
  tag: 'snap-close-button',
  styleUrl: 'snap-close-button.scss',
  scoped: true,
})
export class SnapCloseButton {
  @Prop() color: CLOSEBUTTON_COLORS_TYPES = 'gray'
  @State() isMobile: boolean = false

  @Event({ eventName: 'snap-close-button-clicked', bubbles: true, composed: true }) snapCloseButtonClicked: EventEmitter<void>

  private mobileScreenWidth = 768

  @Listen('resize', { target: 'window' })
  checkScreen() {
    this.isMobile = document.body.clientWidth < this.mobileScreenWidth
  }

  componentWillLoad() {
    this.checkScreen()
  }

  onClickHandler = () => {
    this.snapCloseButtonClicked.emit()
  }

  render() {
    return (
      <Host class={`snap-close-button-${this.color}`} onClick={this.onClickHandler}>
        <div class={`snap-close-button snap-close-button-${this.color}`}>
          <snap-icon icon="x-solid" size={`${this.isMobile ? 'md' : 'sm'}`} />
        </div>
      </Host>
    )
  }
}
